







import { bookGoodsModelProvider } from '../model'
import { defineClassComponent } from '@/hooks'
import { navigateTo } from '@/router'

export default defineClassComponent(
  () =>
    class {
      bookGoodsModel = bookGoodsModelProvider.inject()

      handleCertClick = () => {
        navigateTo('MartCert', {
          id: this.bookGoodsModel.value.merchantId,
        })
      }
    },
)
